import { render, staticRenderFns } from "./JournalCompte.vue?vue&type=template&id=3b084444&"
import script from "./JournalCompte.vue?vue&type=script&lang=js&"
export * from "./JournalCompte.vue?vue&type=script&lang=js&"
import style0 from "./JournalCompte.vue?vue&type=style&index=0&id=3b084444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports